module.exports = __webpack_public_path__ + "static/media/template-standard.c392c9a2.svg";